import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Input, Label } from "reactstrap";

interface EditDeadlineModalProps {
  isOpen: boolean;
  toggle: () => void;
  currentDeadline: string | null;
  newDeadline: string;
  setNewDeadline: (value: string) => void;
  justification: string;
  setJustification: (value: string) => void;
  onConfirm: () => void;
}

const EditDeadlineModal: React.FC<EditDeadlineModalProps> = ({
  isOpen,
  toggle,
  currentDeadline,
  newDeadline,
  setNewDeadline,
  justification,
  setJustification,
  onConfirm,
}) => (
  <Modal isOpen={isOpen} toggle={toggle} className={`${localStorage.getItem("mode") ? localStorage.getItem("mode") : "light"}`}>
    <ModalHeader>Alterar Prazo de Entrega</ModalHeader>
    <ModalBody className="modal-body-style">
      <div className="mb-3">
        <Label className="theme-text-color">Prazo atual</Label>
        <Input
          className="custom-input theme-text-color"
          type="text"
          disabled
          value={currentDeadline || "Não definido"}
        />
      </div>
      <div className="mb-3">
        <Label className="theme-text-color">Novo prazo</Label>
        <Input
          className="custom-input theme-text-color"
          type="date"
          value={newDeadline}
          onChange={(e) => setNewDeadline(e.target.value)}
        />
      </div>
      <div>
        <Label className="theme-text-color">Justificativa</Label>
        <Input
          type="textarea"
          className="input-modal theme-text-color"
          value={justification}
          onChange={(e) => setJustification(e.target.value)}
          rows={4}
          placeholder="Informe o motivo da alteração do prazo"
        />
      </div>
    </ModalBody>
    <ModalFooter className="modal-footer-style">
      <Button color="primary" onClick={onConfirm}>Confirmar</Button>
      <Button color="secondary" onClick={toggle}>Cancelar</Button>
    </ModalFooter>
  </Modal>
);

export default EditDeadlineModal;
